import { useCallback, useRef } from 'react';
import { useAgentStore } from '@/stores/agentStore';
import { AttachmentItem } from '../types';

export function useAttachmentManager() {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const attachments = useAgentStore((s) => s.attachments);

  const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const newItems: AttachmentItem[] = [];
    Array.from(files).forEach(file => {
      const isMedia = file.type.startsWith('image/') || file.type.startsWith('video/');
      if (isMedia) {
        const url = URL.createObjectURL(file);
        newItems.push({ file, name: file.name, type: file.type, size: file.size, thumbnailUrl: url });
      } else {
        newItems.push({ file, name: file.name, type: file.type, size: file.size });
      }
    });
    useAgentStore.getState().setAttachments(prev => [...prev, ...newItems]);
    e.target.value = '';
  }, []);

  const removeAttachment = useCallback((index: number) => {
    useAgentStore.getState().setAttachments(prev => {
      const item = prev[index];
      if (item.thumbnailUrl) URL.revokeObjectURL(item.thumbnailUrl);
      return prev.filter((_, i) => i !== index);
    });
  }, []);

  return {
    attachments,
    fileInputRef,
    handleFileSelect,
    removeAttachment,
  };
}
